<span class="difficulty-level">
  {{ difficulty }}
</span>

<span class="difficulty-icon">
  <i class="typcn typcn-star"></i>
</span>
